import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";
export class AttributeSetViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getAttributeSets = async () => {
    //CRITICAL - ERROR MESSAGE
    var attributeSetResponse = await this.getAttributeSetListByCodeTag();
    if (
      Format.isNotNull(attributeSetResponse.errorCode) &&
      attributeSetResponse.errorCode === 0
    ) {
      if (Format.isNotNull(attributeSetResponse.attributeSetList)) {
        this.updateState(
          "attributesetList",
          attributeSetResponse.attributeSetList
        );
        this.logger.info(attributeSetResponse.attributeSetList);
      } else {
        this.showEmpty("AttributeSet");
      }
    } else {
      this.showError("AttributeSet", CrudlStatus.LIST);
    }
  };
  getAttributeSetsReturned = async () => {
    //CRITICAL - ERROR MESSAGE
    var attributeSetResponse = await this.getAttributeSetListByCodeTag();
    if (
      Format.isNotNull(attributeSetResponse.errorCode) &&
      attributeSetResponse.errorCode === 0
    ) {
      if (Format.isNotNull(attributeSetResponse.attributeSetList)) {
        this.logger.info(attributeSetResponse.attributeSetList);
        return attributeSetResponse.attributeSetList;
      }
    } else {
      this.showError("AttributeSet", CrudlStatus.LIST);
    }
  };

  getAttributes = async () => {
    //NON CRITICAL - NO ERROR MESSAGE
    var attributeResponse = await this.getAttributeListByCodeTag();
    if (
      Format.isNotNull(attributeResponse.errorCode) &&
      attributeResponse.errorCode === 0
    ) {
      if (Format.isNotNull(attributeResponse.attributeList)) {
        this.updateState("attributeList", attributeResponse.attributeList);
        this.logger.info(attributeResponse.attributeList);
        var attributeArray = UIMap.getListOptions(
          attributeResponse.attributeList,
          "name"
        );
        var attributeMap = UIMap.getDropdownOptionsExtension(
          attributeResponse.attributeList,
          "name",
          "name"
        );
        this.updateState("attributeMap", attributeMap);
        this.updateState("attributeOptions", attributeArray);
      } else {
        //this.showEmpty("Attribute");
      }
    } else {
      //this.showError("Attribute", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (
    attributeSets,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedAttributeSetList = [];
    if (type === CrudlStatus.CREATE) {
      updatedAttributeSetList = this.reloadAfterCreate(
        attributeSets,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedAttributeSetList = this.reloadAfterUpdate(
        attributeSets,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedAttributeSetList = this.reloadAfterDelete(
        attributeSets,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("attributeSetList", updatedAttributeSetList);
  };

  reloadAfterCreate = (attributeSetList, apiResponse, externalStateValues) => {
    if (attributeSetList === undefined || attributeSetList === null) {
      attributeSetList = [];
    }
    var attributeSetBean = externalStateValues.attributeSetBean;
    attributeSetBean.id = apiResponse.id;
    attributeSetBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    attributeSetList.push(attributeSetBean);

    return attributeSetList;
  };

  reloadAfterUpdate = (attributeSetList, apiResponse, externalStateValues) => {
    var i = 0;
    attributeSetList.forEach(e => {
      if (apiResponse.id === e.id) {
        attributeSetList[i] = externalStateValues.attributeSetBean;
        attributeSetList[i].lastUpdatedDateTime =
          apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return attributeSetList;
  };

  reloadAfterDelete = (attributeSetList, apiResponse, externalStateValues) => {
    var i = 0;
    attributeSetList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        attributeSetList.splice(i, 1);
      }
      i++;
    });

    return attributeSetList;
  };
  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let attributeSetRequest = CloudService.AttributeSetRequest.constructFromObject(
      stateVariables.attributeSetBean
    );
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createAttributeSet(attributeSetRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateAttributeSet(attributeSetRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteAttributeSet(attributeSetRequest);
    }
  };

  createAttributeSet = async (attributeSetRequest, stateVariables) => {
    attributeSetRequest.codeTag = this.codeTag;
    attributeSetRequest.userId = this.userId;
    attributeSetRequest.usageType = "PART";

    let attributeSetResponse = await ApiService.attributeSetCreate(
      attributeSetRequest
    );
    if (attributeSetResponse.errorCode === 0) {
      this.showSuccess("AttributeSet", CrudlStatus.CREATE);
    } else {
      this.showError("AttributeSet", CrudlStatus.CREATE);
    }

    return attributeSetResponse;
  };

  deleteAttributeSet = async attributeSetRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = attributeSetRequest.id;
    request.lastUpdatedDateTime = attributeSetRequest.lastUpdatedDateTime;

    let attributeSetResponse = await ApiService.attributeSetDelete(request);
    if (attributeSetResponse.errorCode === 0) {
      this.showSuccess("AttributeSet", CrudlStatus.DELETE);
    } else {
      this.showError("AttributeSet", CrudlStatus.DELETE);
    }

    return attributeSetResponse;
  };

  updateAttributeSet = async (attributeSetRequest, stateVariables) => {
    attributeSetRequest.codeTag = this.codeTag;
    attributeSetRequest.userId = this.userId;
    attributeSetRequest.usageType = "PART";

    delete attributeSetRequest.attributeBeanList;

    let attributeSetResponse = await ApiService.attributeSetUpdate(
      attributeSetRequest
    );
    if (attributeSetResponse.errorCode === 0) {
      this.showSuccess("AttributeSet", CrudlStatus.UPDATE);
    } else {
      this.showError("AttributeSet", CrudlStatus.UPDATE);
    }

    return attributeSetResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/AttributeSet/AttributeSetViewModel.js